import { render, staticRenderFns } from "./PorletDocumentos.vue?vue&type=template&id=8e453e20&"
import script from "./PorletDocumentos.vue?vue&type=script&lang=js&"
export * from "./PorletDocumentos.vue?vue&type=script&lang=js&"
import style0 from "./PorletDocumentos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports